import React, { useState } from "react";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  // 🔷 Handle input change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // 🔷 Validation function
  const validate = () => {
    let newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Enter a valid email";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    }

    return newErrors;
  };

  // 🔷 Submit handler
  const handleSubmit = (e) => {
    e.preventDefault();

    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      alert("Message sent successfully!");
      setFormData({
        name: "",
        email: "",
        message: "",
      });
    }
  };

  return (
    <>
      <style>{`
        .contact-page {
          font-family: Arial, sans-serif;
        }

        /* 🔷 HEADER */
        .contact-header {
          height: 300px;
          background: url("https://images.unsplash.com/photo-1523240795612-9a054b0db644") center/cover no-repeat;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 40px;
          font-weight: bold;
          letter-spacing: 2px;
        }

        /* 🔷 MAIN GRID */
        .contact-container {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          gap: 20px;
          padding: 40px;
        }

        /* 🔷 MAP */
        .map iframe {
          width: 100%;
          height: 100%;
          border: 0;
          border-radius: 10px;
          min-height: 300px;
        }

        /* 🔷 DETAILS */
        .contact-details {
          background: #f5f5f5;
          padding: 20px;
          border-radius: 10px;
        }

        .contact-details h3 {
          margin-bottom: 15px;
        }

        .contact-details p {
          margin: 10px 0;
          color: #555;
        }

        .contact-details a {
          text-decoration: none;
          color: #0072ff;
          font-weight: bold;
        }

        /* 🔷 FORM */
        .contact-form {
          background: #f5f5f5;
          padding: 20px;
          border-radius: 10px;
        }

        .contact-form input,
        .contact-form textarea {
          width: 100%;
          padding: 10px;
          margin-bottom: 8px;
          border: 1px solid #ccc;
          border-radius: 5px;
        }

        .error {
          color: red;
          font-size: 12px;
          margin-bottom: 10px;
        }

        .contact-form button {
          background: linear-gradient(45deg, #00c6ff, #0072ff);
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 20px;
          cursor: pointer;
        }

        .contact-form button:hover {
          opacity: 0.9;
        }

        /* 🔷 RESPONSIVE */
        @media (max-width: 900px) {
          .contact-container {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <div className="contact-page">
        {/* 🔷 HEADER */}
        <div className="contact-header">Contact Us</div>

        {/* 🔷 CONTENT */}
        <div className="contact-container">

          {/* 🔷 GOOGLE MAP */}
          <div className="map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3755.6861292128224!2d84.78205129999999!3d19.7259827!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a22a51ff714d52d%3A0xd9996dee695fd7a5!2sSharada%20Hill%20Modern%20School!5e0!3m2!1sen!2sin!4v1775628878538!5m2!1sen!2sin"
              allowFullScreen=""
              loading="lazy"
              title="School Location"
            ></iframe>
          </div>

          {/* 🔷 CONTACT DETAILS */}
          <div className="contact-details">
            <h3>Meet Us</h3>

            <p>
              📞 <a href="tel:+919692741427">+91 9692741427</a>
            </p>

            <p>
              📧{" "}
              <a href="mailto:sharadahillmodernschool2024@gmail.com">
                sharadahillmodernschool2024@gmail.com
              </a>
            </p>

            <p>📍 Sharada Hill Modern School, Odisha, India</p>
          </div>

          {/* 🔷 CONTACT FORM */}
          <div className="contact-form">
            <h3>Contact</h3>

            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Enter your name"
                value={formData.name}
                onChange={handleChange}
              />
              {errors.name && <div className="error">{errors.name}</div>}

              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && <div className="error">{errors.email}</div>}

              <textarea
                rows="4"
                name="message"
                placeholder="Enter your message"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
              {errors.message && (
                <div className="error">{errors.message}</div>
              )}

              <button type="submit">Send Message</button>
            </form>
          </div>

        </div>
      </div>
    </>
  );
};

export default Contact;